module.exports = __webpack_public_path__ + "static/media/question.a5c4d75f.PNG";